import { useParams, Link } from 'react-router-dom';
import { tvShows, categories } from '@/mocks/tvShows';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ShowCard from '@/components/base/ShowCard';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const currentSlug = slug || 'all';

  const currentCategory = categories.find((c) => c.slug === currentSlug) || categories[0];

  const filteredShows =
    currentSlug === 'all'
      ? tvShows
      : tvShows.filter((s) => s.categories.includes(currentSlug));

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${currentCategory.name} - 91美剧网`,
    description: `91美剧网${currentCategory.name}分类，收录最新热门${currentCategory.name}类美剧，高清画质流畅播放。`,
    url: `https://www.91meiju.com/category/${currentSlug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '91美剧网',
      url: 'https://www.91meiju.com/',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-6">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: currentCategory.name },
              ]}
            />
          </div>

          <section className="w-full max-w-7xl mx-auto px-4 md:px-6 pb-14">
            <div className="mb-8">
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                {currentCategory.name}
              </h1>
              <p className="text-sm text-foreground-400 mt-2">
                共找到 <strong className="text-foreground-700">{filteredShows.length}</strong> 部美剧
              </p>
            </div>

            <div className="flex flex-wrap items-center gap-2 mb-8">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                    currentSlug === cat.slug
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200 hover:text-foreground-950'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            {filteredShows.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5" data-product-shop="">
                {filteredShows.map((show) => (
                  <ShowCard key={show.id} show={show} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
                  <i className="ri-movie-line text-2xl text-foreground-300" />
                </div>
                <p className="text-foreground-400">该分类暂无内容</p>
              </div>
            )}
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}